import Vue from 'vue'
import Vuex, { mapGetters } from 'vuex'
import store from '../store'
import Client from '../services/client'
import Events from '../components/eventsFeed.vue'

Vue.use(Vuex)

const el = document.querySelector('#calendar-feed')
if (el !== null) {
  const vm = new Vue({
    store,
    components: {
      Events
    },
    delimiters: ['[[', ']]'],
    data: {
      section: null,
      relatedTo: [],
      limit: 3,
      siteId: 2
    },
    methods: {
      populateStore () {
        if (this.relatedTo) {
          this.$store.commit('events/UPDATE_SELECTED_CATEGORIES', this.relatedTo)
        }
        this.$store.commit('events/UPDATE_LIMIT', this.limit)
        this.$store.commit('events/UPDATE_SITE_ID', this.siteId)
        this.$store.commit('events/UPDATE_LIMIT', this.limit)
      },
      getResults () {
        Client.getEvents(this.variables)
          .then(response => {
            this.$store.commit('events/UPDATE_RESULTS', response.data.data.entries)
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    computed: {
      ...mapGetters('events', ['variables'])
    },
    watch: {
      variables: function () {
        this.getResults()
      }
    },
    mounted () {
      const feedData = window.feedData
      this.relatedTo = feedData.relatedTo ? [feedData.relatedTo] : []
      this.siteId = feedData.siteId ? feedData.siteId : 2
      this.limit = feedData.limit ? feedData.limit : 3
      this.populateStore()
    }
  })
  vm.$mount(el)
}
